import TrackingList from '@/components/modules/tracking/index';

const tracking = [
  {
    path: '/tracking',
    name: 'Tracking',
    component: TrackingList,
    meta: {
      title: 'Tracking List',
    },
  },
];

export default tracking;
